<div class = "agpr-distributionDashboard-usage-container">
    <div class="agpr-distributionDashboard-usage-flexContainer">
        <div class="agpr-distributionDashboard-usage-column centered">
            <agpr-chart
                class="agpr-distributionDashboard-usage-bigChart"
                [chart]="totalUsageChart"
            >
            </agpr-chart>
        </div>
        <div class="agpr-distributionDashboard-usage-column">
            <div class="agpr-distributionDashboard-usage-row">
                <div class="agpr-distributionDashboard-usage-label">
                    {{'Discover.distributionDashboard.usageInformation.totalRecipients' | localize}}
                </div>
                <div class="agpr-distributionDashboard-usage-number">
                    {{quotaInfo?.totalDistributions | number}}
                </div>
            </div>
            <div class="agpr-distributionDashboard-usage-row padded">
                <div class="agpr-distributionDashboard-usage-label">
                    {{'Discover.distributionDashboard.usageInformation.totalRecipientsUsed' | localize}}
                </div>
                <div class="agpr-distributionDashboard-usage-number">
                    {{quotaInfo?.usedDistributions | number}}
                </div>
            </div>
        </div>
        <div class="agpr-distributionDashboard-usage-column">
            <div class="agpr-distributionDashboard-usage-row">
                <div class="agpr-distributionDashboard-usage-label">
                    {{'Discover.distributionDashboard.usageInformation.recipientsRemaining' | localize}}
                    <span
                        role="img"
                        class="fa-regular fa-circle-info"
                        [agprTooltip]="'Discover.distributionDashboard.getMoreRecipients.message' | localize: {
                                count: quotaInfo?.totalDistributionsAvailable,
                                date: resetDate | date: dateFormat
                        }"
                    ></span>
                </div>
                <div class="agpr-distributionDashboard-usage-number">
                    {{quotaInfo?.totalDistributionsAvailable | number}}
                </div>
            </div>
            <div class="agpr-distributionDashboard-usage-row">
                <div class="agpr-distributionDashboard-usage-smallChart">
                    <agpr-chart
                        [chart]="monthlyUsageChart"
                    >
                    </agpr-chart>
                    <span>{{'Discover.distributionDashboard.chart.monthly' | localize}}</span>
                </div>
            </div>
        </div>
    </div>
    <agpr-quota-message
        [totalUsagePercentage]="totalUsagePercentage"
        [threshold]="75"
        [infoMessage]="resetDate !== null
            ? ('Discover.distributionDashboard.getMoreRecipients.message' | localize: {
                count: quotaInfo?.totalDistributionsAvailable,
                date: resetDate | date: dateFormat
            })
            : ('Discover.distributionDashboard.getMoreRecipients.message.noDate' | localize: {
                count: quotaInfo?.totalDistributionsAvailable
            })
        "
        [warningMessage]="resetDate !== null
            ? ('Discover.distributionDashboard.getMoreRecipients.message' | localize: {
                    count: quotaInfo?.totalDistributionsAvailable,
                    date: resetDate | date: dateFormat
            })
            : ('Discover.distributionDashboard.getMoreRecipients.message.noDate' | localize: {
                    count: quotaInfo?.totalDistributionsAvailable
            })
        "
        [errorMessage]="resetDate !== null
            ? ('Discover.distributionDashboard.getMoreRecipients.message.error' | localize: {
                date: resetDate | date: dateFormat
            })
            : ('Discover.distributionDashboard.getMoreRecipients.message.error.noDate' | localize)
        "
    >
        <p class="errorLink"><ng-container *ngTemplateOutlet="popup"></ng-container></p>
        <ng-template #popup>
            <agpr-button
                [style]="buttonTypes.link"
                label="Discover.distributionDashboard.contactUs"
                (click)="openBuyQuotaDialog.emit()"
                [ngClass]="{
                    'agpr-distributionDashboard-contactLink': true,
                    'agpr-distributionDashboard-contactLink-white' : totalUsagePercentage === 100
                }"
            >
            </agpr-button>
        </ng-template>
    </agpr-quota-message>

    <div class="agpr-distributionDashboard-usage-footer">
        <agpr-button
            [style]="buttonTypes.tertiary"
            label="Discover.distributionDashboard.getMoreRecipients"
            (click)="openBuyQuotaDialog.emit()"
        >
        </agpr-button>
    </div>
</div>
